import { Injectable } from '@angular/core';

import { LoggerContext } from '../../enums/logger-context.enum';

const LOGGER_STORAGE_KEY = 'davinci.logger';

/**
 * Contextual console logging for local debugging.
 * Enable contexts via comma-separated values, e.g.
 * `localStorage.setItem('davinci.logger', 'auth,lienholder,request-tracking')`.
 */
@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  isContextEnabled(context: LoggerContext | string): boolean {
    if (typeof localStorage === 'undefined') {
      return false;
    }

    const raw = localStorage.getItem(LOGGER_STORAGE_KEY);
    if (!raw) {
      return false;
    }

    return raw
      .split(',')
      .map((entry) => entry.trim())
      .filter(Boolean)
      .includes(context);
  }

  info(context: LoggerContext | string, ...args: unknown[]): void {
    if (!this.isContextEnabled(context)) {
      return;
    }
    console.info(...args);
  }

  log(context: LoggerContext | string, ...args: unknown[]): void {
    if (!this.isContextEnabled(context)) {
      return;
    }
    console.log(...args);
  }

  warn(context: LoggerContext | string, ...args: unknown[]): void {
    if (!this.isContextEnabled(context)) {
      return;
    }
    console.warn(...args);
  }

  error(context: LoggerContext | string, ...args: unknown[]): void {
    if (!this.isContextEnabled(context)) {
      return;
    }
    console.error(...args);
  }
}
